import { CloseButton } from "@/components/Search/SearchBar/components/ResultsPanel/components/CloseButton/closeButton";
import { NoResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/NoResults/noResults";
import { Panel } from "@/components/Search/SearchBar/components/ResultsPanel/components/Panel/panel";
import { Results } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/results";
import { useResultsPanelContext } from "@/components/Search/SearchBar/components/ResultsPanel/context/resultsPanel.context";
import { Base } from "@/components/Search/SearchBar/components/ResultsPanel/resultsPanel.base";

export const ResultsPanel = Object.assign(Base, {
    useContext: useResultsPanelContext,
    CloseButton: CloseButton,
    Panel: Panel,
    Results: Results,
    NoResults: NoResults
});
